// removed by extract-text-webpack-plugin
module.exports = {"field-customizer":"field-customizer__field-customizer___2ZgJz"};